import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { CARGOS_SUMMARY } from 'api/query-keys.ts';
import type { CargoTotalsRes } from 'api/swagger';
import { setStatusFiltersToQs, useCargoStatusFilters } from 'shared/hooks/use-cargo-status-filters';
import type { ICargoFilter } from 'shared/stores/use-cargo-filters.ts';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs.ts';
import type { IWithPagination } from 'types/api-query.ts';

interface IParams extends IWithPagination {
  search?: string;
  filters?: ICargoFilter;
  isHints?: boolean;
  isSkip?: boolean;
  includeFromStatuses?: boolean;
}

export const useGetCargosSummary = (params?: IParams) => {
  const { search, filters, isSkip, includeFromStatuses = false } = params || {};

  const { statusFilters, filtersWithoutStatuses } = useCargoStatusFilters({ filters, includeFromStatuses });

  const qs = new URLSearchParams();
  if (search) qs.set('filter[search]', search);
  if (filters) setFiltersToQs<ICargoFilter>(qs, filtersWithoutStatuses);

  setStatusFiltersToQs(qs, statusFilters);

  return useQuery<CargoTotalsRes>({
    queryKey: [CARGOS_SUMMARY, { search, filters }],
    queryFn: async () => {
      const { data } = await http.get<CargoTotalsRes>(`/v1/cargo/total?${qs.toString()}`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 10,
    cacheTime: 10,
    enabled: !isSkip,
  });
};
